import type { FavouritesSummary, StateWithFavourites } from '../types/favourites';

export const selectFavouritesSummary = (state: StateWithFavourites): FavouritesSummary =>
  state.favourites.summary;

export const selectIsFavourite = (summary: FavouritesSummary, productCode: number) =>
  summary.productCodes.includes(String(productCode));
